module.exports = __webpack_public_path__ + "static/media/image12.a71999b6.webp";